import { render } from "./update-department.vue?vue&type=template&id=12dd145c&scoped=true"
import script from "./update-department.vue?vue&type=script&lang=js"
export * from "./update-department.vue?vue&type=script&lang=js"

import "./update-department.vue?vue&type=style&index=0&id=12dd145c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd145c"],['__file',"src/components/applications/admin/update/update-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12dd145c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12dd145c', __exports__)) {
    api.reload('12dd145c', __exports__)
  }
  
  module.hot.accept("./update-department.vue?vue&type=template&id=12dd145c&scoped=true", () => {
    api.rerender('12dd145c', render)
  })

}


export default __exports__